import Store from './Store';

const DbTablesStore = new Store('db/tables/');

export {DbTablesStore};